/**
 * Remote CRDT document IDs deliberately use a URL-safe, product-facing prefix
 * instead of an npm package ID. Package IDs remain the internal app identity.
 */
export function getStorageDocumentPrefix(appId: string): string {
  const firstPartyPrefix = '@yada/app-';
  if (appId.startsWith(firstPartyPrefix)) {
    return appId.slice(firstPartyPrefix.length);
  }

  // Custom namespaces are kept deterministic and path-safe too.
  return appId
    .replace(/^@/, '')
    .replace(/\//g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '-');
}

export function getStorageDocumentId(appId: string, workspaceId: string): string {
  return `${getStorageDocumentPrefix(appId)}--${workspaceId}`;
}

/** The pre-namespace format, retained solely to discover existing synced data. */
export function getLegacyStorageDocumentId(appId: string, workspaceId: string): string {
  return `${appId}-${workspaceId}`;
}
